/* eslint-disable @typescript-eslint/naming-convention */
export class BlackboardData {
  isPageReload: boolean;
  senderId: number;
  bbDrawInfo: BbDrawInfo;
}

export class BbDrawInfo {
  xyArray: Coordinates[] = [];
  color = 'white';
  lineWide = 2;
}

export interface Coordinates {
  x: number;
  y: number;
}

export enum BlackboardTools {
  ERASER = 1,
  TEXT = 2,
  POINTER = 3,
  CLEAN_BOARD = 4,
  DRAW_MODE = 5,
}

export class BlackboardTextModel {
  text: string;
  senderId: number;
}
